module.exports = __webpack_public_path__ + "img/芜湖斑马汽车城.90cad349.jpg";